/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DonationFundDTO,
  DonationFundDTOOptional,
  DonationFundDTOMetaI,
  DonationFundDTOTrackedI,
} from "./donation-fund-dto";
import {
  DonationFundDTOTracked,
  DonationFundDTOMeta,
} from "./donation-fund-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DonationInitiativeDTO,
  DonationInitiativeDTOOptional,
  DonationInitiativeDTOMetaI,
  DonationInitiativeDTOTrackedI,
} from "./donation-initiative-dto";
import {
  DonationInitiativeDTOTracked,
  DonationInitiativeDTOMeta,
} from "./donation-initiative-dto";

/**
 *
 * @export
 * @interface DonationOptionsDTO
 */
export interface DonationOptionsDTOOptional {
  /**
   *
   * @type {Array<DonationFundDTO>}
   * @memberof DonationOptionsDTO
   */
  donationFunds?: DonationFundDTOOptional[];
  /**
   *
   * @type {Array<DonationInitiativeDTO>}
   * @memberof DonationOptionsDTO
   */
  donationInitiatives?: DonationInitiativeDTOOptional[];
}

export interface DonationOptionsDTO extends DonationOptionsDTOOptional {
  /**
   *
   * @type {Array<DonationFundDTO>}
   * @memberof DonationOptionsDTO
   */
  donationFunds?: DonationFundDTO[];
  /**
   *
   * @type {Array<DonationInitiativeDTO>}
   * @memberof DonationOptionsDTO
   */
  donationInitiatives?: DonationInitiativeDTO[];
}

export interface DonationOptionsDTOTrackedI {
  /**
   *
   * @type {Array<DonationFundDTO>}
   * @memberof DonationOptionsDTO
   */
  donationFunds?: DonationFundDTOTrackedI[];
  donationFundsIsSet: boolean;
  /**
   *
   * @type {Array<DonationInitiativeDTO>}
   * @memberof DonationOptionsDTO
   */
  donationInitiatives?: DonationInitiativeDTOTrackedI[];
  donationInitiativesIsSet: boolean;
}

transformDatesMap.set(
  "DonationOptionsDTO",
  function (model: DonationOptionsDTO) {
    const transformDatesdonationFunds =
      transformDatesMap.get("DonationFundDTO");
    if (transformDatesdonationFunds) {
      model.donationFunds?.forEach((sub) => {
        transformDatesdonationFunds(sub);
      });
    }
    const transformDatesdonationInitiatives = transformDatesMap.get(
      "DonationInitiativeDTO",
    );
    if (transformDatesdonationInitiatives) {
      model.donationInitiatives?.forEach((sub) => {
        transformDatesdonationInitiatives(sub);
      });
    }
  },
);

export type DonationOptionsDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  donationFunds: PropertyMeta<DonationFundDTOMetaI>;
  //isDate: false
  //isDatetime: false
  donationInitiatives: PropertyMeta<DonationInitiativeDTOMetaI>;
}>;

export var DonationOptionsDTOMeta: DonationOptionsDTOMetaI =
  {} as DonationOptionsDTOMetaI;
DonationOptionsDTOMeta = typeMeta("DonationOptionsDTO", {
  donationFunds: propertyMeta(
    "donationFunds",
    true,
    false,
    false,
    DonationFundDTOMeta,
  ),
  donationInitiatives: propertyMeta(
    "donationInitiatives",
    true,
    false,
    false,
    DonationInitiativeDTOMeta,
  ),
});

const metaI = DonationOptionsDTOMeta;

registerMeta(() => {});

export class DonationOptionsDTOTracked implements DonationOptionsDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  donationFunds__I?: DonationFundDTOTracked[] = undefined;
  donationFundsIsSet: boolean = false;
  set donationFunds(v: undefined | DonationFundDTOTracked[]) {
    if (v !== undefined) {
      this.donationFunds__I = v;
      this.donationFundsIsSet = true;
    } else {
      this.donationFunds__I = v || undefined;
      this.donationFundsIsSet = false;
    }
    this.changeTracker = true;
  }
  get donationFunds() {
    return this.donationFunds__I;
  }
  donationInitiatives__I?: DonationInitiativeDTOTracked[] = undefined;
  donationInitiativesIsSet: boolean = false;
  set donationInitiatives(v: undefined | DonationInitiativeDTOTracked[]) {
    if (v !== undefined) {
      this.donationInitiatives__I = v;
      this.donationInitiativesIsSet = true;
    } else {
      this.donationInitiatives__I = v || undefined;
      this.donationInitiativesIsSet = false;
    }
    this.changeTracker = true;
  }
  get donationInitiatives() {
    return this.donationInitiatives__I;
  }
  constructor(config?: DonationOptionsDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.donationFunds?.forEach((a) => a.setIds());

    this.donationInitiatives?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: DonationOptionsDTOOptional,
    options?: AssignOptions,
  ): DonationOptionsDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.donationFunds &&
      this.donationFundsApplyFilter(optionsRequired.filter)
    ) {
      this.donationFunds = config.donationFunds?.map(
        (a) => new DonationFundDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.donationFundsIsSet = false;
      else this.donationFundsIsSet = true;
    }
    if (
      config.donationInitiatives &&
      this.donationInitiativesApplyFilter(optionsRequired.filter)
    ) {
      this.donationInitiatives = config.donationInitiatives?.map(
        (a) => new DonationInitiativeDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.donationInitiativesIsSet = false;
      else this.donationInitiativesIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): DonationOptionsDTOTrackedI {
    const cloned = {} as DonationOptionsDTOTrackedI;
    if (
      this.donationFundsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.donationFundsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.donationFundsIsSet = true;
      cloned.donationFunds = this.donationFunds
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.donationFundsIsSet = false
    }
    if (
      this.donationInitiativesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.donationInitiativesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.donationInitiativesIsSet = true;
      cloned.donationInitiatives = this.donationInitiatives
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.donationInitiativesIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): DonationOptionsDTOTrackedI {
    if (!this.donationFundsApplyFilter(filter)) this.donationFundsIsSet = false;

    this.donationFunds?.forEach((a) => a.unassignAll(filter));
    if (!this.donationInitiativesApplyFilter(filter))
      this.donationInitiativesIsSet = false;

    this.donationInitiatives?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  donationFundsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationOptionsDTOMeta.donationFunds,
      DonationOptionsDTOMeta,
      this.donationFunds,
      this,
    );
  }
  donationFundsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.donationFundsIsSet && this.donationFundsApplyFilter(filter))
      return true;

    return this.donationFunds?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  donationInitiativesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationOptionsDTOMeta.donationInitiatives,
      DonationOptionsDTOMeta,
      this.donationInitiatives,
      this,
    );
  }
  donationInitiativesIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.donationInitiativesIsSet &&
      this.donationInitiativesApplyFilter(filter)
    )
      return true;

    return this.donationInitiatives?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.donationFundsIsSetDeep(filter)) return true;
    if (this.donationInitiativesIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
